<template>
  <div class="amountDetail">
    <div class="order_success_line">
      <span>订单金额</span>
      <div class="order_success_right">
        <em>{{orderInfo.total_amount | currency}}</em>
        <div @click="showDetail" style="cursor: pointer;">
          <img :src="isDisabled?downImg:upImg" alt ref="rotImg">
          <i>明细</i>
        </div>
      </div>
    </div>
    <div :style="getDetailStyle" class="order_amount_info order_success_table">
      <table>
        <tr>
          <th id="price_categories">价格种类</th>
          <th>单价</th>
          <th>订购</th>
          <th>应收金额</th>
        </tr>
        <!-- 价格信息 -->
        <!-- <div> -->
        <tr v-for="(orderNum, index) in orderNums" v-if="ticketType[index] != ''">
          <td class="text">{{ticketType[index]}}</td>
          <td>{{ticketPrices[index]}}</td>
          <td>{{orderNum}}</td>
          <td style="color:#313131;">{{ticketPrices[index] | multiply(orderNum)}}</td>
        </tr>
        <!-- 可选项 -->
        <!-- <div > -->
        <!-- <div > -->
        <tr
          v-for="(orderAdditionalCost, index) in orderAdditionalCosts"
          v-if="orderAdditionalCosts.length > 0"
        >
          <td class="text">{{orderAdditionalCost.additional_cost_name}}</td>
          <td>{{orderAdditionalCost.price}}</td>
          <td>{{orderAdditionalCost.num}}</td>
          <td
            style="color:#313131;"
          >{{orderAdditionalCost.price | multiply(orderAdditionalCost.num)}}</td>
        </tr>
        <!-- </div> -->
        <!-- </div> -->
        <!-- 人数优惠 -->
        <!-- <div v-for="(favorableInfo, index) in favorableList"> -->
        <tr v-for="(favorableInfo, index) in favorableList">
          <td class="text">{{favorableInfo.ticket_type}}优惠</td>
          <td>{{favorableInfo.price}}</td>
          <td>{{favorableInfo.num}}</td>
          <td style="color:#313131;">{{favorableInfo.price | multiply(favorableInfo.num) }}</td>
        </tr>
        <!-- </div> -->
        <!-- 提前优惠 -->
        <!-- <div class="orde_price_line" v-for="(advanceInfo, index) in advanceList"> -->
        <tr class="orde_price_line" v-for="(advanceInfo, index) in advanceList">
          <td class="text">{{advanceInfo.ticket_type}}优惠</td>
          <td>{{advanceInfo.price}}</td>
          <td>{{advanceInfo.num}}</td>
          <td style="color:#313131;">{{advanceInfo.price | multiply(advanceInfo.num)}}</td>
        </tr>
        <!-- </div> -->
      </table>
    </div>
  </div>
</template>

<script>
import downImg from '@/assets/images/html/rot_bottom.png'
import upImg from '@/assets/images/html/rot_up.png'
export default {
  name: 'amountDetail',
  data () {
    return {
      isDisabled: true,
      downImg: downImg,
      upImg: upImg,
      // orderInfo:{},
      // orderNums:[],
      // ticketType:[],
      // ticketPrices:[],
      // orderAdditionalCosts:[],
      // advanceList:[],
      // favorableList:[],
    }
  },
  created () {
    //this.getOrderDetail()
  },
  mounted () {

  },
  computed: {
    getDetailStyle () {
      var sty = ''
      if (this.isDisabled) {
        sty = "display:none;"
      }
      return sty
    },

  },
  props: { // 对象的形式可以进行校验  属性名和data中的名字不能相同,
    orderInfo: {
      type: [Object],
      required: true
    },
    orderNums: {
      type: [Array],
      required: true
    },
    ticketPrices: {
      type: [Array],
      required: true
    },
    ticketType: {
      type: [Array],
      required: true
    },
    orderAdditionalCosts: {
      type: [Array],
      required: true
    },
    advanceList: {
      type: [Array],
      required: true
    },
    favorableList: {
      type: [Array],
      required: true
    },
  },
  methods: {
    getOrderDetail () {
    },
    showDetail () {
      this.isDisabled = !this.isDisabled
    }
  },

  template: {},
}
</script>

<style scoped>
@import '../../../assets/css/pages/agent/second_phase.css';
.amountDetail {
  background-color: #ade3ff;
  margin-bottom: 2%;
}
.order_success_line {
  width: 100%;
  display: inline-block;
  margin-bottom: 2%;
  margin-top: 3%;
}
.order_success_line {
  width: 94%;
  display: inline-block;
  margin-bottom: 0%;
  margin-top: 0%;
  padding: 5px 3%;
  padding-top: 9px;
}
.order_success_right img {
  float: right;
  width: 4%;
  vertical-align: middle;
  margin-top: 5px;
}
.order_success_line span {
  float: left;
  color: #898989;
  font-size: 20px;
  width: 20%;
}
.order_success_right em {
  float: left;
  font-size: 20px;
  color: #0075e2;
}
.order_success_right img {
  float: right;
  width: 4%;
  /* margin-top: 1%; */
  vertical-align: middle;
  /* margin-top: 5px; */
  margin-bottom: 0;
  margin-top: 3px;
}
.order_success_right i {
  float: right;
  color: #434343;
  margin-right: 2%;
  font-size: 20px;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/pages/agent/components/amountDetail.vue